import React from 'react';
import { connect } from 'react-redux';

import { required } from '../../../../utils/form-validation';

import {
    Select,
} from '../../../Form';

const SelectEventTag = (props) => {
    const {
        field,
        value,
        onChange,
        coreUI,
    } = props;

    const { eventTags } = coreUI.types.tms;

    return (
        <div className={`col-12 mb12`}>
            <div className="div div16" />
            <div className={`d-flex align-items-start`}>
                <div className={`flex-1`}>
                    <div className={`form-group form-group-xl mb0`}>
                        <label className={`pt16`} htmlFor={'eventTag'} data-testid="selecteventtag.label-26">
                            {'Event Tag'}
                        </label>
                    </div>
                </div>
                <div className={`flex-1`}>
                    <Select
                        id="eventTag"
                        formGroupCssClass={`mb0`}
                        field={field}
                        value={value}
                        options={eventTags}
                        onChange={(val) => {
                            if (onChange) {
                                onChange(val);
                            }
                        }}
                        validate={required}
                        hiddenLabel={true}
                        data-testid="event-edit.event-tag-select"
                    />
                </div>
            </div>
        </div>
    );
};

function mapStateToProps({ coreUI }) {
    return { coreUI };
}

export default connect(mapStateToProps)(SelectEventTag);
